import React from 'react';

import classNames from 'classnames';

export default function PanelIcon(props) {
  const iconFade =
    props.scrolledAmount < 20 ? 'popup--fade-in' : 'popup--fade-out';

  return (
    <div
      className={classNames(
        'popup__porthole transition-enabled tw-border-white tw-bg-mint-500 [&_svg_path]:tw-fill-white',
        iconFade,
      )}
    >
      <props.Icon height={32} width={32} />
    </div>
  );
}
